// import React, { useState, useEffect } from "react";
// import { saveAs } from "file-saver";
// import * as XLSX from "xlsx";
// import "./Appointment.css";

// const AppointmentTable = () => {
//   const [appointments, setAppointments] = useState([]);
//   const [slots, setSlots] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [currentPage, setCurrentPage] = useState(1);
//   const appointmentsPerPage = 5;
//   const [sortKey, setSortKey] = useState("appointmentDate");
//   const [sortOrder, setSortOrder] = useState("asc");
//   const [doctors, setDoctors] = useState([]);

//   const [newAppointment, setNewAppointment] = useState({
//     slotId: "",
//     doctorId: "",
//     patientFirstName: "",
//     patientLastName: "",
//     patientEmail: "",
//     patientNumber: "",
//     patientAddress: "",
//     appointmentDate: "",
//     reason: "",
//     status: "Scheduled",
//     appointmentType: "Consultation",
//     priority: "Normal",
//     startTime: "",
//     endTime: ""
//   });

//   const API_URL = "http://3.110.167.23:8080/api/v1";
//   const TOKEN = `Bearer ${localStorage.getItem("authToken")}`;

//   useEffect(() => {
//     fetchAppointments();
//   }, []);
//   useEffect(() => {
//     const fetchDoctors = async () => {
//       try {
//         const response = await fetch(`${API_URL}/users`, {
//           headers: {
//             Authorization: TOKEN,
//           },
//         });
//         const data = await response.json();
//         const doctorUsers = data.filter((user) =>
//           user.roles?.some((role) => role.name === "DOCTOR")
//         );
//         setDoctors(doctorUsers);
//       } catch (error) {
//         console.error("Failed to fetch doctors:", error);
//       }
//     };
  
//     fetchDoctors();
//   }, []);
  
//   const fetchAppointments = async () => {
//     try {
//       const response = await fetch(`${API_URL}/appointments`, {
//         headers: {
//           Authorization: TOKEN,
//           "Content-Type": "application/json",
//         },
//       });
//       const data = await response.json();
//       setAppointments(data);
//     } catch (err) {
//       console.error("Failed to fetch appointments:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (newAppointment.doctorId && newAppointment.appointmentDate) {
//       fetch(`${API_URL}/appointments/slots/all?doctorId=${newAppointment.doctorId}&date=${newAppointment.appointmentDate}`, {
//         headers: { Authorization: TOKEN },
//       })
//         .then((res) => res.json())
//         .then((data) => setSlots(data))
//         .catch((err) => console.error("Failed to fetch slots:", err));
//     }
//   }, [newAppointment.doctorId, newAppointment.appointmentDate]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setNewAppointment((prev) => ({ ...prev, [name]: value }));
//   };

//   const addAppointment = async () => {
//     try {
//       const response = await fetch(`${API_URL}/appointments/book`, {
//         method: "POST",
//         headers: {
//           Authorization: TOKEN,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(newAppointment),
//       });
//       const saved = await response.json();
//       setAppointments([...appointments, saved]);
//       setShowAddModal(false);
//     } catch (err) {
//       console.error("Booking failed:", err);
//       alert("Booking failed");
//     }
//   };

//   const deleteAppointment = async (id) => {
//     try {
//       await fetch(`${API_URL}/appointments/${id}`, {
//         method: "DELETE",
//         headers: { Authorization: TOKEN },
//       });
//       setAppointments(appointments.filter((appt) => appt.id !== id));
//     } catch (err) {
//       alert("Failed to delete appointment");
//     }
//   };

//   const exportToExcel = () => {
//     const worksheet = XLSX.utils.json_to_sheet(appointments);
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Appointments");
//     const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
//     const data = new Blob([excelBuffer], { type: "application/octet-stream" });
//     saveAs(data, "appointments.xlsx");
//   };

//   const handleSort = (key) => {
//     const order = key === sortKey && sortOrder === "asc" ? "desc" : "asc";
//     setSortKey(key);
//     setSortOrder(order);
//   };

//   const filteredSortedAppointments = appointments
//     .filter((a) => (a.patientFirstName || "").toLowerCase().includes(searchQuery.toLowerCase()))
//     .sort((a, b) => {
//       const valA = a[sortKey] || "";
//       const valB = b[sortKey] || "";
//       if (valA < valB) return sortOrder === "asc" ? -1 : 1;
//       if (valA > valB) return sortOrder === "asc" ? 1 : -1;
//       return 0;
//     });

//   const indexOfLast = currentPage * appointmentsPerPage;
//   const indexOfFirst = indexOfLast - appointmentsPerPage;
//   const currentAppointments = filteredSortedAppointments.slice(indexOfFirst, indexOfLast);

//   return (
//     <>
//     <div className="appointment-table w-100 shadow rounded bg-white px-3">
//       <div className="table-header">
//         <h4>Appointments</h4>
//         <div>
//           <input
//             className="search"
//             placeholder="Search by name..."
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//           />
//           <button onClick={() => setShowAddModal(true)} className="btn bg-primary rounded border-0 px-2 py-2 text-white ms-2">+ Add</button>
//           <button onClick={exportToExcel} className="btn bg-success rounded border-0 px-2 py-2 text-white ms-2">Export</button>
//         </div>
//       </div>

//       {loading ? (
//         <p>Loading appointments...</p>
//       ) : (
//         <table >
//           <thead>
//             <tr>
//               <th onClick={() => handleSort("patientFirstName")}>Patient</th>
//               <th>Email</th>
//               <th>Mobile</th>
//               <th onClick={() => handleSort("appointmentDate")}>Date</th>
//               <th>Time</th>
//               <th>Doctor ID</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {currentAppointments.map((a) => (
//               <tr key={a.id}>
//                 <td>{a.patientFirstName} {a.patientLastName}</td>
//                 <td>{a.patientEmail}</td>
//                 <td>{a.patientNumber}</td>
//                 <td>{a.appointmentDate}</td>
//                 <td>{a.startTime} - {a.endTime}</td>
//                 <td>{a.doctorId}</td>
//                 <td>{a.status}</td>
//                 <td>
//                   <button onClick={() => deleteAppointment(a.id)} className="btn bg-danger rounded border-0 text-white">🗑</button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       )}

//       <div className="pagination">
//         {[...Array(Math.ceil(filteredSortedAppointments.length / appointmentsPerPage)).keys()].map(n => (
//           <button
//             key={n + 1}
//             onClick={() => setCurrentPage(n + 1)}
//             className={currentPage === n + 1 ? "active" : ""}
//           >
//             {n + 1}
//           </button>
//         ))}
//       </div>
//       {showAddModal && (
//         <div className="modal-overlay" onClick={() => setShowAddModal(false)}>
//           <div className="modal-details" onClick={(e) => e.stopPropagation()}>
//             <h3>Book Appointment</h3>
//             <div className="modal-form-grid row">
//               <div className="col-md-6">
//                 <input name="patientFirstName" placeholder="First Name" className="form-control mb-2" value={newAppointment.patientFirstName} onChange={handleInputChange} />
//               </div>
//               <div className="col-md-6">
//                 <input name="patientLastName" placeholder="Last Name" className="form-control mb-2" value={newAppointment.patientLastName} onChange={handleInputChange} />
//               </div>
//               <div className="col-md-6">
//                 <input name="patientEmail" placeholder="Email" className="form-control mb-2" value={newAppointment.patientEmail} onChange={handleInputChange} />
//               </div>
//               <div className="col-md-6">
//                 <input name="patientNumber" placeholder="Phone" className="form-control mb-2" value={newAppointment.patientNumber} onChange={handleInputChange} />
//               </div>
//               <div className="col-md-6">
//                 <input name="patientAddress" placeholder="Address" className="form-control mb-2" value={newAppointment.patientAddress} onChange={handleInputChange} />
//               </div>
//               <div className="col-md-6">
//                 <input type="date" name="appointmentDate" className="form-control mb-2" value={newAppointment.appointmentDate} onChange={handleInputChange} />
//               </div>
//               <div className="col-md-6">
//                 <select name="doctorId" className="form-select mb-2" value={newAppointment.doctorId} onChange={handleInputChange}>
//                   <option value="">Select Doctor</option>
//                   {doctors.map((doc) => (
//                     <option key={doc.id} value={doc.id}>{doc.fullName || doc.email}</option>
//                   ))}
//                 </select>
//               </div>
//               <div className="col-md-6">
//                 <select name="slotId" className="form-select mb-2" value={newAppointment.slotId} onChange={handleInputChange}>
//                   <option value="">Select Slot</option>
//                   {slots.map((slot) => (
//                     <option key={slot.slotId} value={slot.slotId}>{slot.startTime} - {slot.endTime}</option>
//                   ))}
//                 </select>
//               </div>
//               <div className="col-md-6">
//                 <input name="reason" placeholder="Reason" className="form-control mb-2" value={newAppointment.reason} onChange={handleInputChange} />
//               </div>
//               <div className="col-md-6">
//                 <select name="status" className="form-select mb-2" value={newAppointment.status} onChange={handleInputChange}>
//                   <option>Scheduled</option>
//                   <option>Completed</option>
//                   <option>Canceled</option>
//                 </select>
//               </div>
//               <div className="col-md-6">
//                 <select name="appointmentType" className="form-select mb-2" value={newAppointment.appointmentType} onChange={handleInputChange}>
//                   <option>Consultation</option>
//                   <option>Follow-up</option>
//                 </select>
//               </div>
//               <div className="col-md-6">
//                 <select name="priority" className="form-select mb-2" value={newAppointment.priority} onChange={handleInputChange}>
//                   <option>Normal</option>
//                   <option>High</option>
//                   <option>Low</option>
//                 </select>
//               </div>
//             </div>

//             <div className="d-flex justify-content-end gap-2 mt-4">
//               <button
//                 className="btn btn-secondary"
//                 onClick={() => setShowAddModal(false)}
//               >
//                 Close
//               </button>
//               <button
//                 className="btn btn-primary"
//                 onClick={addAppointment}
//               >
//                 Submit
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//     </div>
//     </>
//   );
// };

// export default AppointmentTable;




import React, { useState, useEffect } from "react";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import "./Appointment.css";

const AppointmentTable = () => {
  const [appointments, setAppointments] = useState([]);
  const [slots, setSlots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAddModal, setShowAddModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingAppointmentId, setEditingAppointmentId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const appointmentsPerPage = 5;
  const [sortKey, setSortKey] = useState("appointmentDate");
  const [sortOrder, setSortOrder] = useState("asc");
  const [doctors, setDoctors] = useState([]);

  const [newAppointment, setNewAppointment] = useState({
    slotId: "",
    doctorId: "",
    patientFirstName: "",
    patientLastName: "",
    patientEmail: "",
    patientNumber: "",
    patientAddress: "",
    appointmentDate: "",
    reason: "",
    status: "Scheduled",
    appointmentType: "Consultation",
    priority: "Normal",
    startTime: "",
    endTime: ""
  });

  const API_URL = "http://3.110.167.23:8080/api/v1";
  const TOKEN = `Bearer ${localStorage.getItem("authToken")}`;

  useEffect(() => {
    fetchAppointments();
  }, []);

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        const response = await fetch(`${API_URL}/users`, {
          headers: {
            Authorization: TOKEN,
          },
        });
        const data = await response.json();
        const doctorUsers = data.filter((user) =>
          user.roles?.some((role) => role.name === "DOCTOR")
        );
        setDoctors(doctorUsers);
      } catch (error) {
        console.error("Failed to fetch doctors:", error);
      }
    };
  
    fetchDoctors();
  }, []);
  
  const fetchAppointments = async () => {
    try {
      const response = await fetch(`${API_URL}/appointments`, {
        headers: {
          Authorization: TOKEN,
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      setAppointments(data);
    } catch (err) {
      console.error("Failed to fetch appointments:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (newAppointment.doctorId && newAppointment.appointmentDate) {
      fetch(`${API_URL}/appointments/slots/all?doctorId=${newAppointment.doctorId}&date=${newAppointment.appointmentDate}`, {
        headers: { Authorization: TOKEN },
      })
        .then((res) => res.json())
        .then((data) => setSlots(data))
        .catch((err) => console.error("Failed to fetch slots:", err));
    }
  }, [newAppointment.doctorId, newAppointment.appointmentDate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewAppointment((prev) => ({ ...prev, [name]: value }));
  };

  const addAppointment = async () => {
    try {
      const response = await fetch(`${API_URL}/appointments/book`, {
        method: "POST",
        headers: {
          Authorization: TOKEN,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newAppointment),
      });
      const saved = await response.json();
      setAppointments([...appointments, saved]);
      setShowAddModal(false);
      resetForm();
    } catch (err) {
      console.error("Booking failed:", err);
      alert("Booking failed");
    }
  };

  const editAppointment = async () => {
    try {
      const response = await fetch(`${API_URL}/appointments/${editingAppointmentId}`, {
        method: "PATCH",
        headers: {
          Authorization: TOKEN,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newAppointment),
      });
      const updated = await response.json();
      setAppointments(
        appointments.map((appt) =>
          appt.id === editingAppointmentId ? updated : appt
        )
      );
      setShowAddModal(false);
      setIsEditing(false);
      setEditingAppointmentId(null);
      resetForm();
    } catch (err) {
      console.error("Failed to update appointment:", err);
      alert("Failed to update appointment");
    }
  };

  const deleteAppointment = async (id) => {
    try {
      await fetch(`${API_URL}/appointments/${id}`, {
        method: "DELETE",
        headers: { Authorization: TOKEN },
      });
      setAppointments(appointments.filter((appt) => appt.id !== id));
    } catch (err) {
      alert("Failed to delete appointment");
    }
  };

  const handleEditClick = (appointment) => {
    setNewAppointment({
      slotId: appointment.slotId || "",
      doctorId: appointment.doctorId || "",
      patientFirstName: appointment.patientFirstName || "",
      patientLastName: appointment.patientLastName || "",
      patientEmail: appointment.patientEmail || "",
      patientNumber: appointment.patientNumber || "",
      patientAddress: appointment.patientAddress || "",
      appointmentDate: appointment.appointmentDate || "",
      reason: appointment.reason || "",
      status: appointment.status || "Scheduled",
      appointmentType: appointment.appointmentType || "Consultation",
      priority: appointment.priority || "Normal",
      startTime: appointment.startTime || "",
      endTime: appointment.endTime || ""
    });
    setEditingAppointmentId(appointment.id);
    setIsEditing(true);
    setShowAddModal(true);
  };

  const resetForm = () => {
    setNewAppointment({
      slotId: "",
      doctorId: "",
      patientFirstName: "",
      patientLastName: "",
      patientEmail: "",
      patientNumber: "",
      patientAddress: "",
      appointmentDate: "",
      reason: "",
      status: "Scheduled",
      appointmentType: "Consultation",
      priority: "Normal",
      startTime: "",
      endTime: ""
    });
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(appointments);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Appointments");
    const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "appointments.xlsx");
  };

  const handleSort = (key) => {
    const order = key === sortKey && sortOrder === "asc" ? "desc" : "asc";
    setSortKey(key);
    setSortOrder(order);
  };

  const filteredSortedAppointments = appointments
    .filter((a) => (a.patientFirstName || "").toLowerCase().includes(searchQuery.toLowerCase()))
    .sort((a, b) => {
      const valA = a[sortKey] || "";
      const valB = b[sortKey] || "";
      if (valA < valB) return sortOrder === "asc" ? -1 : 1;
      if (valA > valB) return sortOrder === "asc" ? 1 : -1;
      return 0;
    });

  const indexOfLast = currentPage * appointmentsPerPage;
  const indexOfFirst = indexOfLast - appointmentsPerPage;
  const currentAppointments = filteredSortedAppointments.slice(indexOfFirst, indexOfLast);

  return (
    <>
    <div className="appointment-table w-100 shadow rounded bg-white px-3">
      <div className="table-header">
        <h4>Appointments</h4>
        <div>
          <input
            className="search"
            placeholder="Search by name..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button onClick={() => { setShowAddModal(true); setIsEditing(false); resetForm(); }} className="btn btn-color rounded border-0 px-2 py-2 text-white ms-2">+ Add</button>
          <button onClick={exportToExcel} className="btn btn-color rounded border-0 px-2 py-2 text-white ms-2">Export</button>
        </div>
      </div>

      {loading ? (
        <p>Loading appointments...</p>
      ) : (
        <table>
          <thead className="tableborder"> 
            <tr>
              <th onClick={() => handleSort("patientFirstName")}>Patient</th>
              <th>Email</th>
              <th>Mobile</th>
              <th onClick={() => handleSort("appointmentDate")}>Date</th>
              <th>Time</th>
              <th>Doctor ID</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {currentAppointments.map((a) => (
              <tr key={a.id} className="datahover">
                <td>{a.patientFirstName} {a.patientLastName}</td>
                <td>{a.patientEmail}</td>
                <td>{a.patientNumber}</td>
                <td>{a.appointmentDate}</td>
                <td>{a.startTime} - {a.endTime}</td>
                <td>{a.doctorId}</td>
                <td>{a.status}</td>
                <td>
                  <button onClick={() => handleEditClick(a)} className="btn btn-color rounded border-0 text-white me-2">✏️</button>
                  <button onClick={() => deleteAppointment(a.id)} className="btn bg-danger rounded border-0 text-white">🗑</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <div className="pagination">
        {[...Array(Math.ceil(filteredSortedAppointments.length / appointmentsPerPage)).keys()].map(n => (
          <button
            key={n + 1}
            onClick={() => setCurrentPage(n + 1)}
            className={currentPage === n + 1 ? "active" : ""}
          >
            {n + 1}
          </button>
        ))}
      </div>
      {showAddModal && (
        <div className="modal-overlay" onClick={() => { setShowAddModal(false); setIsEditing(false); resetForm(); }}>
          <div className="modal-details" onClick={(e) => e.stopPropagation()}>
            <h3>{isEditing ? "Edit Appointment" : "Book Appointment"}</h3>
            <div className="modal-form-grid row">
              <div className="col-md-6">
                <input name="patientFirstName" placeholder="First Name" className="form-control mb-2" value={newAppointment.patientFirstName} onChange={handleInputChange} />
              </div>
              <div className="col-md-6">
                <input name="patientLastName" placeholder="Last Name" className="form-control mb-2" value={newAppointment.patientLastName} onChange={handleInputChange} />
              </div>
              <div className="col-md-6">
                <input name="patientEmail" placeholder="Email" className="form-control mb-2" value={newAppointment.patientEmail} onChange={handleInputChange} />
              </div>
              <div className="col-md-6">
                <input name="patientNumber" placeholder="Phone" className="form-control mb-2" value={newAppointment.patientNumber} onChange={handleInputChange} />
              </div>
              <div className="col-md-6">
                <input name="patientAddress" placeholder="Address" className="form-control mb-2" value={newAppointment.patientAddress} onChange={handleInputChange} />
              </div>
              <div className="col-md-6">
                <input type="date" name="appointmentDate" className="form-control mb-2" value={newAppointment.appointmentDate} onChange={handleInputChange} />
              </div>
              <div className="col-md-6">
                <select name="doctorId" className="form-select mb-2" value={newAppointment.doctorId} onChange={handleInputChange}>
                  <option value="">Select Doctor</option>
                  {doctors.map((doc) => (
                    <option key={doc.id} value={doc.id}>{doc.fullName || doc.email}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-6">
                <select name="slotId" className="form-select mb-2" value={newAppointment.slotId} onChange={handleInputChange}>
                  <option value="">Select Slot</option>
                  {slots.map((slot) => (
                    <option key={slot.slotId} value={slot.slotId}>{slot.startTime} - {slot.endTime}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-6">
                <input name="reason" placeholder="Reason" className="form-control mb-2" value={newAppointment.reason} onChange={handleInputChange} />
              </div>
              <div className="col-md-6">
                <select name="status" className="form-select mb-2" value={newAppointment.status} onChange={handleInputChange}>
                  <option>Scheduled</option>
                  <option>Completed</option>
                  <option>Canceled</option>
                </select>
              </div>
              <div className="col-md-6">
                <select name="appointmentType" className="form-select mb-2" value={newAppointment.appointmentType} onChange={handleInputChange}>
                  <option>Consultation</option>
                  <option>Follow-up</option>
                </select>
              </div>
              <div className="col-md-6">
                <select name="priority" className="form-select mb-2" value={newAppointment.priority} onChange={handleInputChange}>
                  <option>Normal</option>
                  <option>High</option>
                  <option>Low</option>
                </select>
              </div>
            </div>

            <div className="d-flex justify-content-end gap-2 mt-4">
              <button
                className="btn btn-secondary"
                onClick={() => { setShowAddModal(false); setIsEditing(false); resetForm(); }}
              >
                Close
              </button>
              <button
                className="btn btn-color"
                onClick={isEditing ? editAppointment : addAppointment}
              >
                {isEditing ? "Update" : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
    </>
  );
};

export default AppointmentTable;
